export default __webpack_public_path__ + "static/media/29.fa62ff0e.png";